import React from "react";
import {activityService} from "../jwt/_services/core/activityService";

export const activityProvider = {
    getItem,
    getOptions,
    show
};

async function getOptions(customFilter) {
    try {
        const listItems = await activityService.getOptions( customFilter );
        const data = listItems?.data
        const items = data.map((item, index) => {
            const  {id, code, name} = item
            const label = (code != null) ? `${code.toUpperCase()} - ` : ''
            return {
                id: id,
                value: `${code}-${name}`,
                label: <label>{label} <b>{ name }</b> </label>
            }
        });

        return items
    } catch (error) {
        console.log(error.message);
    }
}

async function getItem(id){
    try {
        const item = await activityService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}

async function show(id, db){
    try {
        return await activityService.show(id, db);
    } catch (error) {
        console.error(error.message)
        return null
    }
}